import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-text_primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-primary_hover flex items-center justify-center">
                <span className="text-white font-bold text-lg font-heading">A</span>
              </div>
              <h3 className="text-xl font-bold font-heading">AfriOne B&D</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              {t('heroSubtitle')}
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">{t('quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-home">{t('home')}</Link></li>
              <li><Link to="/products" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-products">{t('products')}</Link></li>
              <li><Link to="/delivery" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-delivery">{t('delivery')}</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-about">{t('about')}</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-contact">{t('contact')}</Link></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">{t('contactInfo')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">Rue St Nicolas 227, Belgique</span>
              </li>
              <li>
                <a href="tel:0465710117" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-phone-1">
                  <Phone className="w-5 h-5 text-primary" />
                  <span className="text-sm">0465 71 01 17</span>
                </a>
              </li>
              <li>
                <a href="tel:0465288417" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-phone-2">
                  <Phone className="w-5 h-5 text-primary" />
                  <span className="text-sm">0465 28 84 17</span>
                </a>
              </li>
              <li>
                <a href="mailto:bamouss883@gmail.com" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-email">
                  <Mail className="w-5 h-5 text-primary" />
                  <span className="text-sm">bamouss883@gmail.com</span>
                </a>
              </li>
            </ul>
          </div>
          
          {/* Hours */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">Horaires</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>Lun - Ven: 9h30 - 20h</li>
              <li>Sam - Dim: 10h - 19h30</li>
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} AfriOne B&D. {t('rights')}.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-white/50 text-sm">Made with ❤️ in Belgium</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
